<template>
  <CarouselBase :carousel-list="carouselList">
    <template #card="{ item }">
      <CardProduct
        :title="item.name"
        :description="item.description || ''"
        :image-url="item.imageUrl"
        :button-name="item.buttonName"
        :to="item.buttonUrl"
        :has-image-border="hasImageBorder"
        :is-click-card="isClickCard"
        @card-click="$emit('click-callback', item)"
      />
    </template>
  </CarouselBase>
</template>

<script setup lang="ts">
  import type { IProductCarousel } from '@/components/Shared/Carousel/types';

  interface IProps {
    carouselList: IProductCarousel[];
    hasImageBorder?: boolean;
    isClickCard: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    carouselList: () => [],
    hasImageBorder: true,
    isClickCard: true,
  });

  defineEmits<{
    (e: 'click-callback', item: IProductCarousel): void;
  }>();
</script>
